// extracted by mini-css-extract-plugin
export default {"modalOverlay":"EvaluationModal_modalOverlay__tR12Q","modal":"EvaluationModal_modal__RTz+E","textarea":"EvaluationModal_textarea__v+Buw","button":"EvaluationModal_button__yH+nm"};